import * as React from 'react';
import { Button } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../../store';
import { trainingActionCreators } from '../../store/Training';
import { ChoiceValue, InterpretValue, CardOption } from '../../types/TrainingTypes';
import { mainActionCreators } from './../../store/Main';
import InterpretAssess from './InterpretAssess';
import ChoiceOptions from './ChoiceOptions';

export default function Main() {
    const trainingState = useAppSelector(state => state.training);
    const state = useAppSelector(state => state.main);
    const dispatch = useAppDispatch();
    const [isTimerActive, setIsTimerActive] = React.useState(false);

    let borderColor = undefined;
    const reviews = trainingState.card?.resultInfo?.reviews;
    if (reviews && reviews >= 700)
        borderColor = '#001dda';
    else if (reviews && reviews >= 600)
        borderColor = '#4400da';
    else if (reviews && reviews >= 500)
        borderColor = '#9e00da';
    else if (reviews && reviews >= 400)
        borderColor = '#da0092';
    else if (reviews && reviews >= 300)
        borderColor = '#da0000';
    else if (reviews && reviews >= 200)
        borderColor = '#da6400'
    else if (reviews && reviews >= 100)
        borderColor = '#c5a900';

    function getHint() {
        dispatch(mainActionCreators.showHint());
    }

    function showExample() {
        dispatch(mainActionCreators.toggleExample());
    }

    function showSolution() {
        dispatch(mainActionCreators.showSolution());
    }

    function assess(assessmentValue: InterpretValue) {
        dispatch(trainingActionCreators.interpretAssess(assessmentValue));
        dispatch(trainingActionCreators.nextCard());
    };

    function toggleExample() {
        dispatch(mainActionCreators.toggleExample());
    }

    function showOptions() {
        dispatch(mainActionCreators.showOptions());
    }

    function nextCard() {
        dispatch(trainingActionCreators.nextCard());
    }


    function chooseOption(option: CardOption | undefined, isLong: boolean) {
        if (!isTimerActive) {
            const isCorrect = option?.content === state.solution;
            if (trainingState.isSolutionShown) {
                if (option?.content === state.solution || !trainingState.isServicePanelEnabled)
                    nextCard();
            }
            else {
                if (isCorrect && !trainingState.isServicePanelEnabled) {
                    setIsTimerActive(true);
                    setTimeout(() => {
                        setIsTimerActive(false);
                        nextCard();
                    }, 500);
                }
                dispatch(mainActionCreators.chooseOption(option));

                const assessmentValue = isCorrect
                    ? isLong
                        ? ChoiceValue.Know
                        : ChoiceValue.Correct
                    : isLong
                        ? ChoiceValue.Decrease
                        : ChoiceValue.Incorrect;
                const time = new Date().getTime() - new Date(state.shownTime!).getTime();

                let difficulty = Math.min(20, (6 + state.task.length));
                let correctOptionPassed = false;
                for (let i = 0; i < state.options.length; i++) {
                    difficulty += (Math.min(20, (6 + state.options[i].content.length)) * (correctOptionPassed ? 0.6 : 1));
                    correctOptionPassed ||= (state.options[i].content === option?.content);
                }
                dispatch(trainingActionCreators.choiceAssess(assessmentValue, time, Math.round(difficulty)));
            }
        }
    }

    return (
        <>
            <div className="flex-grow-1 w-100 width-limit d-flex flex-column text-break">
                <div style={{ minHeight: !state.isOptionsShown && !trainingState.isSolutionShown ? '13.6rem' : !state.isOptionsShown ? undefined : '13.3rem' }}>
                    <div className="training-box mb-2 mb-sm-3"
                        style={{ borderColor: borderColor }}>
                        <div>
                            <span className="task">{state.task}</span>
                            {state.taskAux &&
                                <>
                                    <br />
                                    <span className="text-secondary"> {state.taskAux}</span>
                                </>
                            }
                        </div>
                    </div>

                    {(state.example || state.taskForms) &&
                        <div className="training-box mb-2 mb-sm-3" onDoubleClick={toggleExample}>
                            {(state.example && (trainingState.isSolutionShown || state.isExampleShown))
                                ?
                                <div className="example">
                                    <span style={{ whiteSpace: 'pre-wrap' }}>{state.example}</span>
                                </div>
                                :
                                state.taskForms
                                    ?
                                    <div>
                                        <span className="text-secondary">{state.taskForms}</span>
                                    </div>
                                    :
                                    <></>
                            }
                        </div>
                    }
                </div>

                {!state.isOptionsShown ?
                    !trainingState.isSolutionShown ?
                        <>
                            <div className="width-limit">
                                <div className="row g-2 g-sm-3 mt-2">
                                    <div className="col-12">
                                        <Button variant="light"
                                            size="lg"
                                            onClick={showOptions}>
                                            Show options
                                        </Button>
                                    </div>

                                    {!state.example ?
                                        <div className="col-12">
                                            <Button variant="light"
                                                size="lg"
                                                onClick={getHint}>
                                                Hint
                                            </Button>
                                        </div>
                                        :
                                        <div className="col-12">
                                            <Button variant="light"
                                                size="lg"
                                                onClick={showExample}
                                                disabled={!((!state.isExampleShown && state.example) || (state.isExampleShown && state.taskForms))}
                                                className="px-1">
                                                {state.isExampleShown && state.taskForms ?
                                                    <>Show forms</>
                                                    :
                                                    <>Show example</>
                                                }
                                            </Button>
                                        </div>
                                    }
                                    <div className="col-12">
                                        <Button variant="light"
                                            size="lg"
                                            onClick={showSolution}>
                                            Show meaning
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        <>
                            <div className="training-box mb-3">
                                <div className="solution">
                                    <span style={{ whiteSpace: 'pre-wrap' }}>{state.maskedSolution}</span>
                                    {state.maskedSolutionAux &&
                                        <span className="text-secondary"> {state.maskedSolutionAux}</span>
                                    }
                                    {state.maskedSolutionForms &&
                                        <span className="text-secondary"> {state.maskedSolutionForms}</span>
                                    }
                                </div>
                            </div>

                            <InterpretAssess assess={assess} />
                        </>
                    : <>
                        <ChoiceOptions options={state.options}
                            backgrounds={state.backgrounds}
                            chooseOption={chooseOption} />
                    </>
                }


                {trainingState.isSolutionShown && state.similar &&
                    <ul className="list-unstyled mt-2 mb-0 fs-5">
                        {state.similar.map(x =>
                            <li key={x.id}><span className="fw-bold">
                                {x.phrase}</span>{x.dictionaryName ? ` (${x.dictionaryName})` : ``} - {x.meaning}
                            </li>
                        )}
                    </ul>
                }
            </div >
        </>
    );
}
